import classNames from 'classnames';
import isUndefined from 'lodash/isUndefined';

import {ReactComponent as LempIconSvg} from 'src/Assets/Icons/lemp.svg';
import {ISvgIconProps} from 'src/Components/Icons/ISvgIconProps';

const LempIcon = (props: ISvgIconProps) => {
	const classes = ['svg-icon svg-icon__lemp'];

	if (!isUndefined(props.className)) {
		classes.push(props.className);
	}

	return <LempIconSvg className={classNames(classes)} />;
};

export default LempIcon;
